exports.SPANISH_TRANSLATE = {
  //! Traduccion Menu
  DATA_MAINTENANCE: "Mantenimiento de datos",
  DATA_MAINTENANCE_TYPES: "Tipos",
  DATA_MAINTENANCE_HOLDER: "Titulares",
  DATA_MAINTENANCE_OTHER: "Otros",
  HOLDERS: "Titulares",
  OFFICES: "Oficinas",
  OFFICE: "Oficina",
  COUNTRIES: "Países",
  COUNTRY: "País",
  CALENDAR: "Agenda",
  LOCATIONS: "Localidades",
  TYPES_OF_DOCUMENTS: "Tipos de documentos",
  SAMPLE_TYPES: "Tipos de muestra",
  SAMPLE_TYPE: "Tipo de muestra",
  MEDICAL_INSTITUTIONS: "Instituciones médicas",
  MEDICAL_INSTITUTION: "Institución médica",
  CLIENTS: "Clientes",
  MEDICAL_SPECIALTIES: "Especialidades médicas",
  SPECIALTY: "Especialidad",
  SPECIALTIES: "Especialidades",
  DOCTORS: "Médicos",
  DOCTOR: "Médico",
  HEADLINES: "Titulares",
  WITNESSES: "Testigos",
  ETHNIC_ORIGIN: "Origen étnico",
  INDIVIDUALS: "Individuos",
  STAGE: "Etapa",
  STAGES: "Etapas",
  TECHNIQUES: "Técnicas",
  TECHNIQUE: "Técnica",
  KINSHIPS: "Parentescos",
  KINSHIP: "Parentesco",
  TYPES_OF_CLINICAL_ANALYSIS: "Tipos de análisis clínicos",
  TYPE_OF_CLINICAL_ANALYSIS: "Tipo de análisis clínico",
  PICK_TYPE_OF_CLINICAL_ANALYSIS: "Seleccione un tipo de análisis clínico",
  TYPES_OF_PATERNITY_STUDIES: "Tipos de estudios de paternidad",
  TYPE_OF_PATERNITY_STUDY: "Tipo de estudio de paternidad",
  PICK_TYPE_OF_PATERNITY_STUDY: "Seleccione un tipo de estudio de paternidad",
  PRODUCTS: "Productos",
  PRODUCT: "Producto",
  GENETIC_MARKERS: "Marcadores genéticos",
  MARKER: "Marcador génetico",
  CLINICAL_ANALYZES: "Análisis clínicos",
  CLINICAL_ANALYSIS: "Análisis clínico",
  CLINICAL_ANALYSIS_DATA: "Datos del análisis clínico",
  CLINICAL_ANALYSIS_SHEET: "Ficha de análisis clínico",
  SHOW_CLINICAL_ANALYSIS: "Abrir análisis",
  LIST: "Listado",
  NEW: "Nuevo",
  OUTBOX: "Bandeja de salida",
  INBOX: "Bandeja de entrada",
  CREATE_ANALYSIS_FROM_SPREADSHEET: "Crear análisis desde planilla",
  CREATE_STUDIES_FROM_SPREADSHEET: "Crear estudios desde panilla",
  IMPORT_RESULTS_FROM_SPREADSHEET: "Importar resultados desde planilla",
  CREATE_PROSPECTS_FROM_SPREADSHEET: "Crear prospecto desde planilla",
  IMPORT_GENEMAPPER: "Importar archivo - Genemapper",
  PATERNITY_STUDIES: "Estudios de paternidad",
  PATERNITY_STUDY: "Estudio de paternidad",
  PATERNITY_STUDY_SHEET: "Ficha de estudio",
  CALCULATE_PATERNITY: "Calcular paternidad",
  PROSPECTS: "Prospectos",
  PROSPECT: "Prospecto",
  SECURITY: "Seguridad",
  TASKS: "Tareas",
  USER: "Usuario",
  USERS: "Usuarios",
  CHANGE_PASSWORD: "Cambiar contraseña",
  PASSWORD_CHANGE: "Cambio de clave personal",
  PASSWORDS_NOT_MATCH: "La clave y su repetición no coinciden",
  ROLES: "Roles",
  TOOLS: "Herramientas",
  SYSTEM_PARAMS: "Parámetros del sistema",
  LOGOUT: "Cerrar sesión de {{value}}",
  NEXT: "Siguiente",
  BACK: "Anterior",
  LOGIN: "Ingresar",
  PASSWORD: "Contraseña",
  CONFIRM_PASSWORD: "Confirmar contraseña",
  CURRENT_PASSWORD: "Contraseña actual",
  NEW_PASSWORD: "Nueva contraseña",
  PASSWORD_SPECIFICATIONS:
    "La contraseña debe contener al menos una mayúscula, una minúscula, un número y algún símbolo (@, $, !, %, *, ?, &, #)",
  PASSWORD_LENGTH: "El mínimo de extensión de la contraseña es: 8",
  EMAIL: "Email",
  ROLE: "Rol",
  EXTRACTION_METHOD: "Método de extracción",
  EXTRACTION_METHODS: "Métodos de extracción",
  ALLELE_1: "Alelo 1",
  ALLELE_2: "Alelo 2",
  ALLELE_3: "Alelo 3",
  PASSWORD_REQUIRED: "Contraseña requerida",
  CURRENT_PASSWORD_REQUIRED: "Se requiere contraseña actual",
  EMAIL_REQUIRED: "Email requerido",
  NAME_REQUIRED: "Nombre requerido",
  COLOR_REQUIRED: "Color requerido",
  COLOR_CONTRAST_INVALID: "El contraste no es suficiente",
  SHORT_NAME_REQUIRED: "Nombre corto requerido",
  LASTNAME_REQUIRED: "Apellido requerido",
  USERNAME_REQUIRED: "Nombre de usuario requerido",
  DOCUMENT_TYPE_REQUIRED: "Tipo de documento requerido",
  DOCUMENT_INVALID: "Documento inválido",
  DOCUMENT_INVALID_FORMAT: "Formato del documento inválido",
  DOCUMENT_REQUIRED: "Documento requerido",
  PHONE_REQUIRED: "Teléfono requerido",
  LOCATION_REQUIRED: "Localidad requerida",
  ADDRESS_REQUIRED: "Dirección requerida",
  CODE_REQUIRED: "Código requerido",
  NUMBER_REQUIRED: "Número requerido",
  SERIE_REQUIRED: "Serie requerida",
  TITLE_REPORT_REQUIRED: "El título del informe es requerido",
  DEADLINE_REQUIRED: "El plazo es requerido",
  DEADLINE_TYPE_REQUIRED: "El tipo de plazo es requerido",
  TECHNIQUE_REQUIRED: "La técnica es requerida",
  COORDINATION_TYPE_REQUIRED: "Tipo de coordinación requerida",
  INDIVIDUAL_REQUIRED: "El individuo es requerido",
  TYPE_ANALYSIS_CLINICAL_REQUIRED: "Tipo de análisis clínico requerido",
  TYPE_PATERNITY_STUDY_REQUIRED: "Tipo de paternidad requerido",
  MEDICAL_INSTITUTION_REQUIRED: "Institución médica requerida",
  DOCTOR_REQUIRED: "Médico requerido",
  UBICATION_REQUIRED: "Ubicación requerida",
  MAIN_EXTRACTION_REQUIRED: "Extracción primaria requerida",
  CLIENT_REQUIRED: "Cliente requerido",
  METHOD_REQUIRED: "Método requerido",
  TACOS_RECEIVED_REQUIRED: "Tacos recibidos requeridos",
  PROCESSED_TACOS_REQUIRED: "Tacos procesados requeridos",
  QUANTITY_REQUIRED: "Cantidad requerida",
  CONCENTRATION_REQUIRED: "Concentración requerida",
  TEAM_REQUIRED: "Equipo requerido",
  BOX_REQUIRED: "Caja requerida",
  COLUMN_REQUIRED: "Columna requerida",
  ROW_REQUIRED: "Fila requerida",
  METHODOLOGY_REQUIRED: "Se requiere un metodología",
  RESULT_REQUIRED: "Se requiere una resultado",
  INTERPRETATION_REQUIRED: "Se requiere una interpretación",
  CONCLUSION_REQUIRED: "Se requiere una conclusión",
  SAMPLE_REQUIRED: "Se necesita al menos una muestra",
  SAMPLE_TYPE_REQUIRED: "Se necesita al menos un tipo de muestra",
  OFFICE_REQUIRED: "Oficina requerida",
  COMPANY_REQUIRED: "Se requiere el nombre de la compañia",
  TRUCKING_NUMBER_REQUIRED: "Se requiere el número de rastreo",
  ETHNIC_ORIGIN_REQUIRED: "Se require origen étnico",
  GENDER_REQUIRED: "Se requiere sexo biológico",
  TASKS_REQUIRED: "Tarea(s) requerida(s)",
  SAP_CODE_REQUIRED: "Se requiere código sap",
  SOCIAL_REASON_REQUIRED: "Razón social requerida",
  COUNTRY_REQUIRED: "País requerido",
  PRICE_REQUIRED: "Precio requerido",
  FORMAT_REQUIRED: "Formato requerido",
  FILE_REQUIRED: "Se necesita el archivo para continuar",
  DESCRIPTION_REQUIRED: "Descripción requerida",
  NURSE_REQUIRED: "Enfermero/a requerido/a",
  DATE_REQUIRED: "Fecha requerida",
  DATES_REQUIRED: "Fechas requeridas",
  SUPPORTED_FILES_NOT_SELECTED: "No se seleccionaron archivos compatibles",
  SUPPORTED_FILE_EXTENSION: "Extensión/es de archivo soportada",
  DETAILS: "Detalles",
  STUDY_DATA: "Datos del estudio",
  EMPTY_DATA: "Sin Dato",
  SELECT_DATA: "Seleccione un dato",
  LOCATION_DATA: "Datos de ubicación",
  TYPE_OF_CLINICAL_ANALYSIS_SEARCH: "La búsqueda se realiza sobre los siguientes campos: nombre, código y serie",
  TYPE_OF_PATERNITY_STUDY_SEARCH: "La búsqueda se realiza sobre los siguientes campos: nombre, código y serie",
  INDIVIDUAL_SEARCH: "Búsqueda de individuos",
  INDIVIDUAL_SEARCH_FIELDS: "La búsqueda se realiza sobre los siguientes datos: código, nombres, apellidos, número de documento, oficina y país",
  WITNESS_SEARCH: "Búsqueda de testigos",
  WITNESS_SEARCH_FIELDS: "La búsqueda se realiza sobre los siguientes datos: nombres, apellidos, número de documento",
  MEDICAL_INSTITUTION_SEARCH: "Búsqueda de instituciones médicas",
  MEDICAL_INSTITUTION_SEARCH_FIELDS: "La búsqueda se realiza sobre los siguientes datos: id, nombre, dirección, país, teléfono, email",
  DOCTOR_SEARCH: "Búsqueda de médicos",
  DOCTOR_SEARCH_FIELDS: "La búsqueda se realiza sobre los siguientes datos: nombre, documento, matrícula, país",
  NURSE_SEARCH: "Búsqueda de enfermeros",
  NURSE_SEARCH_FIELDS: "La búsqueda se realiza sobre los siguientes datos: nombre, documento",
  SELECT_DOCTOR: "Seleccione un médico",
  SELECT_MEDICAL_INSTITUTION: "Selecciona una institución médica",
  CREATE_NEW_INDIVIDUAL: "Crear nuevo individuo",
  SELECTION_OF_INDIVIDUALS: "Selección de individuos",
  SAMPLE_INPUT: "Ingreso de muestras",
  EMPTY_OBSERVATIONS: "Sin observaciones",
  EMPTY_INDIVIDUAL: "Sin individuo",
  ALL_DATA: "Todos",
  SAVE: "Guardar",
  ACCEPT: "Aceptar",
  CANCEL: "Cancelar",
  CLOSE: "Cerrar",
  FIRST_NAME: "Primer nombre",
  SECOND_NAME: "Segundo nombre",
  FIRST_LASTNAME: "Primer apellido",
  SECOND_LASTNAME: "Segundo apellido",
  BIRTH_DATE: "Fecha nacimiento",
  REGISTRATION_DATE: "Fecha de registro",
  ENTER: "Ingresar",
  EMPTY_DETAILS: "Sin detalles",
  CLEAN: "Limpiar",
  CLEAN_SECTION: "Limpiar sección",
  CLEAN_FILTERS: "Limpiar filtros",
  SEARCH: "Buscar",
  AUTOCOMPLETE: "Autocompletar",
  TYPE: "Tipo",
  CONFIRMATION: "Confirmación",
  CONFIRM_ACTION: "Desea confirmar esta acción",
  YES: "Sí",
  NO: "No",
  SERIE: "Serie",
  NUMBER: "Número",
  COPY_NUMBER: "Número de copia",
  COPY_DATE: "Fecha de ingreso",
  COPY_NUMBER_SMALL: "Nº copia",
  COPY: "Copiar",
  COPY_NAME: "Copia",
  RELATIONSHIP: "Parentesco",
  DELETE: "Eliminar",
  EDIT: "Editar",
  DATE: "Fecha",
  HOUR: "Hora",
  START_TIME: "Hora de inicio",
  END_TIME: "Hora de fin",
  START_TIME_REQUIRED: "Hora de inicio requerida",
  END_TIME_REQUIRED: "Hora de fin requerida",
  CODE: "Código",
  ORIGIN_CODE: "Código de origen",
  DM_CODE: "Código práctica DM",
  LOT: "Lote",
  LOT_MAX_LENGTH: "El lote debe tener {{ max_length }} caracteres como máximo",
  STATUS: "Estado",
  STATUS_ACTIVE:
    "Este registro está activo, por lo que aparecerá en futuras búsquedas",
  STATUS_INACTIVE:
    "Este registro está inactivo, por lo que NO aparecerá en futuras búsquedas",
  SHOW: "Ver",
  IS_FINAL: "Es final",
  STAGE_IS_FINAL_REQUIRED: "Debes marcar al menos una etapa como final",
  SELECT: "Seleccionar",
  DOWNLOAD: "Descargar",
  CHANGE_CLIENT: "Cambiar cliente",
  TITLE_REPORT: "Título para el informe",
  DEADLINE: "Plazo",
  DAYS: "{{value}} día/s",
  DEADLINE_TYPE: "Tipo de plazo",
  METHODOLOGIES: "Metodologías",
  METHODOLOGY: "Metodología",
  INTERPRETATION: "Interpretación",
  CONCLUSION: "Conclusión",
  RESULTS: "Resultados",
  RESULT: "Resultado",
  ADD_RESULT: "Agregar resultado",
  DEADLINE_TYPE_NORMAL: "Días de corrido",
  DEADLINE_TYPE_BUSSINESS: "Días de hábiles",
  DEADLINE_TYPE_OTHER: "Otros",
  DESCRIPTION: "Descripción",
  PROCESSED_TACOS: "Tacos procesados",
  TACOS_RECEIVED: "Tacos recibidos",
  QUANTITY: "Cantidad",
  MICROLITERS: "Microlitros",
  CONCENTRATION: "Concentración",
  NANOGRAM_PER_MICROLITER: "Nanogramo por microlitro",
  DEVOLUTION_DATE: "Fecha devolución",
  METHOD: "Método",
  //! Nuevo estudio de paternidad
  TYPE_OF_STUDY: "Tipo de estudio",
  DATE_OF_ADMISSION: "Fecha de ingreso",
  ADMISSION: "Ingreso",
  FROM: "Desde",
  TO: "Hasta",
  CLIENT: "Cliente",
  NURSE: "Enfermero/a",
  RECORDS: "Antecedentes",
  RECIPIENTS: "Destinatarios",
  RECIPIENTS_EMPTY: "Sin destinatarios",
  NEW_CLIENT: "Nuevo cliente",
  SELECT_CLIENT: "Seleccione un cliente",
  CLEAR_SELECTION: "Limpiar selección",
  CLIENT_SEARCH: "Búsqueda de clientes",
  CLIENT_SEARCH_FIELDS: "La busqueda se realiza sobre los siguientes datos: id, nombre, razón social, documento, código SAP y país",
  CREATE_NEW_CLIENT: "Crear nuevo cliente",
  NAME: "Nombre",
  ORDER: "Orden",
  COLOR: "Color",
  SHORT_NAME: "Nombre corto",
  GM_NAME: "Nombre GM",
  FORMAT: "Formato",
  LASTNAME: "Apellido",
  USERNAME: "Nombre de usuario",
  SOCIAL_REASON: "Razón social",
  SAP_CODE: "Código SAP",
  CURRENCY: "Moneda",
  PRICE: "Precio",
  DOLLAR: "Dólar",
  LOCAL_CURRENCY: "Moneda local",
  DOCUMENT_TYPE: "Tipo de documento",
  DOCUMENT: "Documento",
  PROFESSIONAL_LICENSE: "Licencia profesional",
  PHONE: "Teléfono",
  ADDRESS: "Dirección",
  DEVOLUTION_ADDRESS: "Dirección de devolución",
  LOCATION: "Localidad",
  UBICATION: "Ubicación",
  TEAM: "Equipo",
  BOX: "Caja",
  ROW: "Fila",
  COLUMN: "Columna",
  ORIGIN: "Origen",
  MAIN_EXTRACTION: "Extracción primaria",
  VALUE: "Valor",
  INDIVIDUAL_INFORMATION: "Información del individuo",
  NURSE_INFORMATION: "Información del enfermero/a",
  CONTACT_INFORMATION: "Información del contacto",
  YOU_CONTACT_INFORMATION: "Información de contacto",
  CLIENT_INFORMATION: "Información de cliente",
  COMPLETE_INFORMATION: "Completar información",
  ASSIGN_PROFILES: "Asignación de perfil a los individuos",
  IMPORT_PROFILES: "Importar perfiles",
  CONTACT_NAME: "Nombre del contacto",
  CONTACT_PHONE: "Teléfono del contacto",
  CONTACT_EMAIL: "Email del contacto",
  OBSERVATION: "Observación",
  OBSERVATIONS: "Observaciones",
  OFFICE_DATA: "Datos de oficina",
  STAGE_DATA: "Datos de etapa",
  TECHNIQUE_DATA: "Datos de técnica",
  TYPE_OF_CLINICAL_ANALYSIS_DATA: "Datos del tipo de análisis clínico",
  TYPE_OF_PATERNITY_STUDY_DATA: "Datos del tipo de estudio de paternidad",
  POSTAL_CODE: "Código postal",
  ENTER_INDIVIDUALS_FROM_THE_BOTTOM:
    "Ingrese individuos desde la parte inferior",
  ADD_INDIVIDUALS: "Agregar individuos",
  ADD_INDIVIDUAL: "Agregar individuo",
  INDIVIDUAL: "Individuo",
  INSTITUTION: "Institución",
  NEW_INDIVIDUAL: "Nuevo individuo",
  GENDER: "Sexo biológico",
  GENDERS: "Sexo biológicos",
  COORDINATION_TYPE: "Tipo de coordinación",
  COORDINATION_TYPES: "Tipos de coordinación",
  NURSES: "Enfermeros",
  APPOINTMENT_SECTOR: "Sector de cita",
  APPOINTMENT_SECTORS: "Sectores de cita",
  TASK_NAME: "Nombre tarea",
  ADD_TRACE: "Agregar traza",
  ADD_SAMPLE: "Agregar muestra",
  ADD_SAMPLES: "Agregar muestras",
  SAMPLE_DATA: "Datos de la muestra",
  EXTRACTION_DATE: "Fecha de extracción",
  TYPE_OF_SAMPLE: "Tipo de muestra",
  EXTRACTIONIST: "Extraccionista",
  EXTRACTIONIST_DATA: "Datos extraccionista",
  EXTRACTIONIST_NAME: "Nombre extraccionista",
  EXTRACTIONIST_DOCUMENT: "Documento extraccionista",
  EXTRACTIONIST_DOCUMENT_TYPE: "Tipo documento extraccionista",
  WITHOUT_EXTRACTIONIST: "Sin extraccionista asociado",
  WITNESS_DATA: "Datos testigo",
  USER_DATA: "Datos del usuario",
  ROLE_DATA: "Datos del rol",
  GENDER_DATA: "Datos del sexo biológico",
  COORDINATION_TYPE_DATA: "Datos del tipo de coordinación",
  SPECIALTY_DATA: "Datos de la especialidad",
  DOCTOR_DATA: "Datos del médico",
  COUNTRY_DATA: "Datos del país",
  KINSHIP_DATA: "Datos del parentesco",
  APPOINTMENT_SECTOR_DATA: "Datos del sector de citas",
  MEDICAL_INSTITUTION_DATA: "Datos de la institución médica",
  PRODUCT_DATA: "Datos del producto",
  SAMPLE_TYPE_DATA: "Datos del tipo de muestra",
  DOCUMENT_TYPE_DATA: "Datos del tipo de documento",
  MARKER_DATA: "Datos del marcador",
  ETHNIC_ORIGIN_DATA: "Datos de origen étnico",
  PROSPECT_DATA: "Información del prospecto",
  EXTRACTION_METHOD_DATA: "Datos del método de extracción",
  NEW_APPOINTMENT_SECTOR: "Nuevo sector de cita",
  NEW_WITNESS: "Nuevo testigo",
  NEW_OFFICE: "Nueva oficina",
  NEW_STAGE: "Nueva etapa",
  NEW_TECHNIQUE: "Nueva técnica",
  NEW_TYPE_ANALYSIS_CLINICAL: "Nuevo tipo de análisis clínicos",
  NEW_USER: "Nuevo usuario",
  NEW_PATERNITY_STUDIE: "Nuevo estudio de paternidad",
  NEW_CLINICAL_ANALYSIS: "Nuevo análisis clínico",
  NEW_ROLE: "Nuevo rol",
  NEW_LOCATION: "Nueva localidad",
  NEW_GENDER: "Nuevo sexo biológico",
  NEW_NURSE: "Nuevo enfermero/a",
  NEW_COORDINATION_TYPE: "Nuevo tipo de coordinación",
  NEW_SPECIALTY: "Nueva especialidad",
  NEW_DOCTOR: "Nuevo médico",
  NEW_COUNTRY: "Nuevo país",
  NEW_KINSHIP: "Nuevo parentesco",
  NEW_MEDICAL_INSTITUTION: "Nueva institución médica",
  NEW_ETHNIC_ORIGIN: "Nuevo origen étnico",
  NEW_PRODUCT: "Nuevo producto",
  NEW_TYPE_PATERNITY_STUDY: "Nuevo tipo de estudio de paternidad",
  NEW_SAMPLE_TYPE: "Nuevo tipo de muestra",
  NEW_DOCUMENT_TYPE: "Nuevo tipo de documento",
  NEW_MARKER: "Nuevo marcador",
  NEW_PROSPECT: "Nuevo prospecto",
  NEW_EXTRACTION_METHOD: "Nuevo método",
  WITNESS: "Testigo",
  WITNESS_NAME: "Nombre testigo",
  WITNESS_LASTNAME: "Apellido testigo",
  WITNESS_DOCUMENT: "Documento testigo",
  WITNESS_EMAIL: "Email testigo",
  WITNESS_ADDRESS: "Dirección testigo",
  WITNESS_PHONE: "Teléfono testigo",
  WITHOUT_WITNESS: "Sin testigo asociado",
  THE_SAMPLES_ENTERED_WILL_BE_DISPLAYED_HARA:
    "Las muestras ingresadas se visualizarán aquí",
  YOU_MUST_SELECT_AT_LEAST_TWO_INDIVIDUALS:
    "Debe seleccionar como minimo dos individuos",
  ALL_INDIVIDUALS_MUST_HAVE_AN_ASSOCIATED_RELATIONSHIP:
    "Todos los individuos deben tener un parentesco asociado",
  THERE_MUST_BE_TWO_DIFFERENT_TYPES_OF_RELATIONSHIPS:
    "Deben haber dos tipos de parentescos diferentes",
  THE_INDIVIDUAL_MUST_HAVE_A_FIRST_NAME: "El individuo debe tener un nombre",
  THE_INDIVIDUAL_MUST_HAVE_A_FIRST_LASTNAME:
    "El individuo debe tener un primer apellido",
  THE_INDIVIDUAL_MUST_HAVE_A_TYPE_OF_DOCUMENT:
    "El individuo debe tener un tipo de documento",
  THE_INDIVIDUAL_MUST_HAVE_A_DOCUMENT: "El individuo debe tener un documento",
  THE_INDIVIDUAL_MUST_HAVE_A_GENDER: "El individuo debe tener un sexo biológico",
  THE_INDIVIDUAL_MUST_HAVE_A_ETHNIC_ORIGIN:
    "El individuo debe tener un origen étnico",
  THE_INDIVIDUAL_MUST_HAVE_A_ADDRESS: "El individuo debe tener una dirección",
  THE_INDIVIDUAL_MUST_HAVE_A_LOCATION: "El individuo debe tener una localidad",
  THERE_IS_ALREADY_AN_INDIVIDUAL_WITH_THAT_DOCUMENT:
    "Ya agrego un individuo con ese documento",
  SELECT_A_WITNESS_OR_ENTER_A_NEW_ONE:
    "Seleccione un testigo o ingrese uno nuevo",
  ENTER_A_MEANS_OF_CONTACT_FOR_THE_WITNESS:
    "Ingrese un medio de contacto del testigo",
  ENTER_THE_WITNESS_DOCUMENT: "Ingrese el documento del testigo",
  ENTER_THE_WITNESS_LOCATION: "Ingrese la localidad del testigo",
  ENTER_THE_WITNESS_ADDRESS: "Ingrese la dirección del testigo",
  SELECT_A_DOCUMENT_TYPE_FOR_THE_WITNESS:
    "Seleccione un tipo de documento para el testigo",
  ENTER_THE_LAST_NAME_OF_THE_WITNESS: "Ingrese el apellido del testigo",
  ENTER_THE_NAME_OF_THE_WITNESS: "Ingrese el nombre del testigo",
  ENTER_THE_EXTRACTIONIST_DOCUMENT: "Ingrese el documento del extraccionista",
  ENTER_THE_TYPE_OF_DOCUMENT_OF_THE_EXTRACTIONIST:
    "Ingrese el tipo de documento del extraccionista",
  ENTER_THE_NAME_OF_THE_EXTRACTIONIST: "Ingrese el nombre del extraccionista",
  PICK_AN_INDIVIDUAL: "Escoja un individuo",
  PICK_NURSE: "Escoja un enfermero",
  CHOOSE_A_SAMPLE_TYPE: "Escoja un tipo de muestra",
  SAMPLE_COORDINATION: "Coordinación toma de muestra",
  SAMPLE_TYPE_ALREADY_EXISTS: "Ya existe un tipo de muestra con ese nombre",

  PATERNITY_STUDIES_LIST_EMPTY:
    "De momento no contamos con ningún estudio de paternidad registrado",
  CLINICAL_ANALYSIS_LIST_EMPTY:
    "De momento no contamos con ningún análisis registrado",
  PATERNITY_STUDIES_LIST_INBOX_EMPTY:
    "De momento no existen estudios de paternidad enviados a su oficina",
  PATERNITY_STUDIES_LIST_OUTBOX_EMPTY:
    "De momento su oficina no ha enviado ningún estudio de paternidad a otra oficina",
  CLINICAL_ANALYSIS_LIST_INBOX_EMPTY:
    "De momento no existen análisis clínicos enviados a su oficina",
  CLINICAL_ANALYSIS_LIST_OUTBOX_EMPTY:
    "En este momento su oficina no ha enviado ningún análisis clínico a otra oficina",
  WITNESS_LIST_EMPTY: "De momento no contamos con ningún testigo registrado",
  OFFICES_LIST_EMPTY: "De momento no contamos con ninguna oficina registrada",
  STAGES_LIST_EMPTY: "De momento no contamos con ninguna etapa registrada",
  TECHNIQUES_LIST_EMPTY: "Por el momento no tenemos ninguna técnica registrada",
  TYPES_ANALYSIS_CLINICAL_LIST_EMPTY:
    "Por el momento no tenemos ningún tipo de análisis clínico registrado",
  INDIVIDUALS_LIST_EMPTY:
    "De momento no contamos con ningún individuo registrado",
  CLINICAL_ANALYSIS_LIST_EMPTY_INDIVIDUAL:
    "Por el momento no tenemos ningún análisis clínico asociado a este individuo",
  SPECIALTIES_LIST_EMPTY_DOCTOR:
    "De momento el médico no cuenta con ninguna especialidad médica",
  USERS_LIST_EMPTY: "Por el momento no tenemos ningún usuario registrado",
  METHODOLOGIES_LIST_EMPTY: "Sin metodologías asignadas",
  RESULTS_LIST_EMPTY: "Sin resultados asignados",
  ROLES_LIST_EMPTY: "De momento no contamos con ningún rol registrado",
  USER_OFFICES_LIST_EMPTY: "Sin oficinas asignadas",
  CLIENTS_LIST_EMPTY: "De momento no contamos con ningún cliente registrado",
  LOCATIONS_LIST_EMPTY:
    "Por el momento no contamos con ninguna localidad registrada",
  GENDERS_LIST_EMPTY: "Por el momento no tenemos ningun sexo biológico registrado",
  APPOINTMENT_SECTOR_LIST_EMPTY:
    "Por el momento no tenemos ningun sector registrado",
  COORDINATION_TYPES_LIST_EMPTY:
    "Por el momento no tenemos ningun tipo registrado",
  SPECIALTIES_LIST_EMPTY:
    "Por el momento no tenemos ninguna especialidad registrada",
  DOCTORS_LIST_EMPTY: "Por el momento no tenemos ningún médico registrado",
  NURSES_LIST_EMPTY: "Por el momento no tenemos ningún enfermero/ra registrado",
  COUNTRIES_LIST_EMPTY: "Por el momento no tenemos ningún país registrado",
  KINSHIPS_LIST_EMPTY: "Por el momento no tenemos ningún parentesco registrado",
  MEDICAL_INSTITUTIONS_LIST_EMPTY:
    "Por el momento no tenemos ningúna institución médica registrada",
  PRODUCTS_LIST_EMPTY: "Por el momento no tenemos ningún producto registrado",
  TYPES_PATERNITY_STUDY_LIST_EMPTY:
    "Por el momento no tenemos ningún tipo de estudio de paternidad registrado",
  ETHNIC_ORIGINS_LIST_EMPTY:
    "Por el momento no tenemos ningún origen étnico registrado",
  SAMPLE_TYPES_LIST_EMPTY:
    "Por el momento no tenemos ningún tipo de muestra registrado",
  MARKERS_LIST_EMPTY:
    "Por el momento no tenemos ningún marcador génetico registrado",
  DOCUMENT_TYPES_LIST_EMPTY:
    "Por el momento no tenemos ningún tipo de documento registrado",
  TASKS_LIST_EMPTY: "De momento no contamos con tareas en el sistema",
  PROSPECTS_LIST_EMPTY: "De momento no tenemos prospectos registrados",
  EXTRACTION_METHODS_LIST_EMPTY:
    "De momento no tenemos métodos de extracción registrados",
  SYSTEM_PARAMS_LIST_EMPTY: "De momento no tenemos parámetros registrados",
  INDIVIDUALS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron individuos con ese filtro",
  PATERNITY_STUDIES_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron estudios de paternidad con ese filtro",
  CLINICAL_ANALYSIS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron análisis con ese filtro",
  WITNESS_LIST_EMPTY_WITH_FILTERS: "No se encontraron testigos con ese filtro",
  OFFICES_LIST_EMPTY_WITH_FILTERS: "No se encontraron oficinas con ese filtro",
  STAGES_LIST_EMPTY_WITH_FILTERS: "No se encontraron etapas con ese filtro",
  TECHNIQUES_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron técnicas con ese filtro",
  TYPES_ANALYSIS_CLINICAL_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron tipos de análisis clínicos con ese filtro",
  USERS_LIST_EMPTY_WITH_FILTERS: "No se encontraron usuarios con ese filtro",
  ROLES_LIST_EMPTY_WITH_FILTERS: "No se encontraron roles con ese filtro",
  CLIENTS_LIST_EMPTY_WITH_FILTERS: "No se encontraron clientes con ese filtro",
  LOCATIONS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron localidades con ese filtro",
  GENDERS_LIST_EMPTY_WITH_FILTERS: "No se encontraron sexos biológicos con ese filtro",
  APPOINTMENT_SECTORS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron sectores con ese filtro",
  COORDINATION_TYPES_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron tipos con ese filtro",
  SPECIALTIES_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron especialidades con ese filtro",
  DOCTORS_LIST_EMPTY_WITH_FILTERS: "No se encontraron médicos con ese filtro",
  NURSES_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron enfermeros/as con ese filtro",
  COUNTRIES_LIST_EMPTY_WITH_FILTERS: "No se encontraron países con ese filtro",
  KINSHIPS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron parentescos con ese filtro",
  MEDICAL_INSTITUTIONS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron instituciones médicas con ese filtro",
  PRODUCTS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron productos con ese filtro",
  TYPES_PATERNITY_STUDY_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron tipos de estudio de paternidad con ese filtro",
  ETHNIC_ORIGINS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron orígenes étnicos con ese filtro",
  SAMPLE_TYPES_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron tipos de muestra con ese filtro",
  DOCUMENT_TYPES_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron tipos de documento con ese filtro",
  MARKERS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron marcadores géneticos con ese filtro",
  TASKS_LIST_EMPTY_WITH_FILTERS: "No se encontraron tareas con ese filtro",
  PROSPECTS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron prospectos con ese filtro",
  EXTRACTION_METHODS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron métodos de extracción con ese filtro",
  SYSTEM_PARAMS_LIST_EMPTY_WITH_FILTERS:
    "No se encontraron parámetros con ese filtro",
  TRANSPORT_EMPTY:
    "Actualmente este análisis clínico no se encuentra en transporte",
  ADVANCED_FILTERS: "Filtros avanzados",
  CURRENT_STAGE: "Etapa actual",
  GROUP_TASKS: "Tareas grupales",
  SAMPLING_VISITS: "Visitas de tomas de muestra",
  SELECTED_STUDIES: "Estudios seleccionados",
  SELECTED_ANALYZES: "Análisis seleccionados",
  SELECTED_PROSPECTS: "Prospectos seleccionados",
  FILTER_STUDIES: "Filtrar estudios",
  FILTER_ANALYZES: "Filtrar análisis",
  FILTER_WITNESSES: "Filtrar testigos",
  FILTER_OFFICES: "Filtrar oficinas",
  FILTER_STAGES: "Filtrar etapas",
  FILTER_TECHNIQUES: "Filtrar técnicas",
  FILTER_TYPES_ANALYSIS_CLINICAL: "Filtrar tipos de análisis clínicos",
  FILTER_INDIVIDUALS: "Filrar individuos",
  FILTER_USERS: "Filtrar usuarios",
  FILTER_ROLES: "Filtrar roles",
  FILTER_CLIENTS: "Filtrar clientes",
  FILTER_LOCATIONS: "Filtrar localidades",
  FILTER_GENDERS: "Filtrar sexos biológicos",
  FILTER_COORDINATION_TYPES: "Filtrar tipos de coordinaciones",
  FILTER_SPECIALTIES: "Filtrar especialidades",
  FILTER_DOCTORS: "Filtrar médicos",
  FILTER_NURSES: "Filtrar enfermeros/as",
  FILTER_COUNTRIES: "Filtrar países",
  FILTER_KINSHIP: "Filtrar parentescos",
  FILTER_MEDICAL_INSTITUTIONS: "Filtrar instituciones médicas",
  FILTER_ETHNIC_ORIGINS: "Filtrar orígenes étnicos",
  FILTER_PRODUCTS: "Filtrar productos",
  FILTER_TYPES_PATERNITY_STUDY: "Filtrar tipos de estudios de paternidad",
  FILTER_SAMPLE_TYPES: "Filtrar tipos de muestra",
  FILTER_DOCUMENT_TYPES: "Filtrar tipos de documentos",
  FILTER_MARKERS: "Filtrar marcadores",
  FILTER_TASKS: "Filtrar tareas",
  FILTER_PROSPECTS: "Filtrar prospectos",
  FILTER_EXTRACTION_METHODS: "Filtrar métodos",
  FILTER_SYSTEM_PARAMS: "Filtrar parámetros",
  FILTER_APPOINTMENT_SECTOR: "Filtrar sectores",
  STUDY_CODE: "Código de estudio",
  STUDY_NUMBER: "Número de estudio",
  SITUATION: "Situación",
  STATE: "Estado",
  PROMISED_DELIVERY: "Fecha prometida",
  TECHNIQUE_SELECTED: "Técnica seleccionada",
  STUDY_TYPE_SELECTED: "Tipo de estudio seleccionado",

  SELECT_INDIVIDUAL: "Seleccione un individuo",
  SELECT_RELATIONSHIP: "Seleccione un parentesco",
  SELECT_SAMPLE_TYPE: "Seleccione un tipo de muestra",
  SELECT_WITNESS: "Seleccione un testigo",
  SELECT_STAGE: "Seleccione una etapa",
  SELECT_STAGES: "Seleccione una o varias etapas",
  SELECT_TASK: "Seleccione tarea",
  SELECT_ALL_PAGE: "Seleccionar toda la página",
  ENTER_DETAIL: "Ingrese un detalle",
  ENTER_OBSERVATION_TRACEABILITY: "Ingrese una observación a la traza",
  OBSERVATION_TRACEABILITY_MAX_LENGTH: "La observación debe tener {{ max_length }} caracteres como máximo",
  STUDY: "Estudio",
  SAMPLES: "Muestras",
  TRANSPORT: "Transporte",
  TRACEABILITY: "Trazabilidad",
  ATTACHMENTS: "Adjuntos",
  ATTACH_FILES: "Adjuntar archivos",
  PICTURE: "Foto",
  FOOTPRINT: "Huella {{value}}",
  SEND_OTHER_OFFICE: "Enviar a otra oficina",
  GENERATE_REPORTS: "Generar Informes",
  EXPORT_REPORTS: "Exportar Listado",
  SEND: "Enviar",
  PROCESS: "Procesar",
  CHECK_VISITS: "Consultar resumen de visitas",
  TAKE_VISITS_REPORT: "Tomar informe de visitas",
  CHANGE_STAGE: "Cambiar etapa",
  CREATE_PATERNITY_OR_ANALYZES: "Crear análisis o paternidades",
  CHANGE_STAGE_MESSAGE_PATERNITY_STUDIES:
    "Los estudios de paternidad cambiarán su etapa a",
  CHANGE_STAGE_MESSAGE_CLINICAL_ANALYSIS:
    "Los análisis clínicos cambiarán su etapa a",
  CHANGE_STAGE_MESSAGE_PROSPECTS: "Los prospectos cambiarán su etapa a",
  CHANGE_CREATE_ANALYZES_OR_STUDIES_PROSPECTS:
    "Seguro que desea crear análisis o paternidades",
  CHANGE_CREATE_ANALYZES_OR_STUDIES_PROSPECTS_MESSAGE:
    "Se creará un estudio de paternidad o un análisis clínico por cada prospecto seleccionado",
  PRINT_LABELS: "Imprimir etiquetas",
  PRINTER: "Impresora",
  FINISH_STUDIES: "Finalizar estudios",
  FINISH_ANALYZES: "Finalizar el/los análisis",
  RECEIVE_SAMPLES: "Recibir muestras",
  SELECT_STAGE_GROUP_TASK: "Seleccione la etapa que se asociara a los estudios",
  SELECT_STAGE_GROUP_TASK_MESSAGE: "Debe seleccionar una etapa",
  SELECT_OFFICE_GROUP_TASK: "Seleccione la oficina destino",
  SELECT_SHIPPING_DETAILS_GROUP_TASK: "Seleccione los datos de envío",
  SELECT_OFFICES: "Seleccione oficina(s)",
  SELECT_OFFICE: "Seleccione oficina",
  SELECT_ROLE: "Seleccione el rol",
  SELECT_SPECIALTY: "Seleccione especialidad",
  SELECT_SPECIALTIES: "Seleccione especialidad(es)",
  SHIPPING_COMPANY_NAME: "Nombre de compañia de envíos",
  TRACKING_NUMBER: "Número de rastreo",
  //! Mensajes
  YOU_MUST_FILL_IN_ALL_FIELDS: "Debes completar todos los campos",
  CONFIRM_DELETE_PATERNITY_STUDY:
    "Seguro que quiere eliminar el estudio de paternidad",
  CONFIRM_DELETE_PATERNITY_STUDY_MESSAGE:
    "Tenga en cuenta que no volverá a ver el estudio de paternidad en el sistema, pero mantendremos una copia de sus datos",
  CONFIRM_DELETE_CLINICAL_ANALYSIS:
    "Seguro que quiere eliminar el análisis clínico",
  CONFIRM_DELETE_CLINICAL_ANALYSIS_MESSAGE:
    "Tenga en cuenta que no volverá a ver el análisis en el sistema, pero mantendremos una copia de sus datos",
  CONFIRM_DELETE_INDIVIDUAL_FROM_PATERNITY_STUDY:
    "Seguro que desea eliminar al individuo",
  CONFIRM_DELETE_INDIVIDUAL_FROM_PATERNITY_STUDY_MESSAGE:
    "Si el individuo mantiene muestras asociadas, también serán eliminadas del estudio de paternidad",
  CONFIRM_DELETE_SAMPLE: "Seguro que desea eliminar la muestra",
  CONFIRM_DELETE_SAMPLE_MESSAGE:
    "Se eliminará por completo la muestra del estudio de paternidad",
  CONFIRM_DELETE_SAMPLE_CLINICAL_MESSAGE:
    "Se eliminará por completo la muestra del análsis clínico",
  CONFIRM_DELETE_TRACEABILITY: "Seguro que desea eliminar la traza",
  CONFIRM_DELETE_TRACEABILITY_MESSAGE:
    "Se eliminará la traza del estudio de paternidad",
  CONFIRM_DELETE_TRACEABILITY_CLINICAL_MESSAGE:
    "Se eliminará la traza del análisis clínico",
  CONFIRM_DELETE_TRACEABILITY_PROSPECT: "Se eliminará la traza del prospecto",
  CONFIRM_DELETE_ATTACHMENT:
    "Está seguro de que desea eliminar el archivo adjunto",
  CONFIRM_DELETE_ATTACHMENT_MESSAGE:
    "Se eliminará el archivo adjunto del estudio de paternidad",
  CONFIRM_DELETE_ATTACHMENT_CLINICAL_MESSAGE:
    "Se eliminará el archivo adjunto del análisis clínico",
  CONFIRM_DELETE_WITNESS: "Está seguro de que desea eliminar el testigo",
  CONFIRM_DELETE_WITNESS_MESSAGE:
    "Tenga en cuenta que no volverá a ver al testigo en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_OFFICE: "Está seguro de que desea eliminar la oficina",
  CONFIRM_DELETE_OFFICE_MESSAGE:
    "Tenga en cuenta que no volverá a ver la oficina en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_STAGE: "Está seguro de que desea eliminar la etapa",
  CONFIRM_DELETE_STAGE_MESSAGE:
    "Tenga en cuenta que no volverá a ver la etapa, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_TECHNIQUE: "Está seguro de que desea eliminar la técnica",
  CONFIRM_DELETE_TECHNIQUE_MESSAGE:
    "Tenga en cuenta que no volverá a ver la técnica, pero guardaremos una copia de sus datos",
  CONFIRM_FINALIZE_STUDIES:
    "Estás seguro de que quieres finalizar los estudios",
  CONFIRM_FINALIZE_STUDIES_MESSAGE:
    "Se finalizarán un total de {{value}} estudios de paternidad",
  CONFIRM_FINALIZE_ANALYZES:
    "Estás seguro de que quieres finalizar los análisis clínicos",
  CONFIRM_FINALIZE_ANALYZES_MESSAGE:
    "Se completará un total de {{value}} análisis clínicos",
  CONFIRM_SEND_STUDIES_TO_OFFICE:
    "Está seguro de que desea enviar estos estudios",
  CONFIRM_SEND_STUDIES_TO_OFFICE_MESSAGE:
    "Se enviará un total de {{value}} estudios de paternidad a la oficina {{name}}",
  CONFIRM_SEND_ANALYZES_TO_OFFICE:
    "Está seguro de que desea enviar estos análisis",
  CONFIRM_SEND_ANALYZES_TO_OFFICE_MESSAGE:
    "Se enviará un total de {{value}} análisis clínicos a la oficina {{name}}",
  CONFIRM_SEND_ANALYSIS_TO_OFFICE:
    "Está seguro de que desea enviar este análisis",
  CONFIRM_SEND_ANALYSIS_TO_OFFICE_MESSAGE:
    "El análisis será enviado a otra oficina",
  CONFIRM_RECEIVE_STUDIES: "Está seguro de que desea aceptar estos estudios",
  CONFIRM_RECEIVE_STUDIES_MESSAGE:
    "Se asignará un total de {{value}} estudios de paternidad a su oficina",
  CONFIRM_RECEIVE_ANALYZES: "Está seguro de que desea aceptar estos análisis",
  CONFIRM_RESULTS_ANALYZES: "Está seguro de confirmar estos resultados",
  CONFIRM_IMPORT_ANALYZES:
    "Está seguro de confirmar estos nuevo/s análisis cliníco/s",
  CONFIRM_IMPORT_GENETIC_PROFILES:
    "Está seguro de confirmar estos nuevos perfiles genéticos",
  CONFIRM_IMPORT_PROSPECTS: "Está seguro de confirmar estos nuevos prospectos",
  CONFIRM_RECEIVE_ANALYZES_MESSAGE:
    "Se asignará un total de {{value}} análisis clínicos a su oficina",
  CONFIRM_DELETE_TYPES_ANALYSIS_CLINICAL:
    "Está seguro de que desea eliminar el tipo de análisis clínico",
  CONFIRM_DELETE_TYPES_ANALYSIS_CLINICAL_MESSAGE:
    "Tenga en cuenta que no volverá a ver el tipo de análisis clínico, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_INDIVIDUAL: "Está seguro de que desea eliminar al individuo",
  CONFIRM_DELETE_INDIVIDUAL_MESSAGE:
    "Tenga en cuenta que no volverá a ver su registro en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_USER: "Está seguro de que desea eliminar el usuario",
  CONFIRM_DELETE_USER_MESSAGE:
    "Tenga en cuenta que este usuario no podrá volver a ingresar al sistema, aun así los datos que hayan sido modificados por él no serán eliminados y seguirán asociados a su cuenta",
  CONFIRM_DELETE_NURSE: "Está seguro de que desea eliminar el enfermero/a",
  CONFIRM_DELETE_NURSE_MESSAGE:
    "Tenga en cuenta que este enfermero/a no podrá volver a ingresar al sistema, aun así los datos que hayan sido modificados por él no serán eliminados y seguirán asociados a su cuenta",
  CONFIRM_DELETE_ROLE: "Está seguro de que desea eliminar el rol",
  CONFIRM_DELETE_ROLE_MESSAGE:
    "Tenga en cuenta que ya no volverá a ver este rol en el sistema, pero mantendremos una copia de sus datos",
  CONFIRM_DELETE_CLIENT: "Está seguro de que desea eliminar el cliente",
  CONFIRM_DELETE_CLIENT_MESSAGE:
    "Tenga en cuenta que ya no verá este cliente en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_LOCATION: "Está seguro de que desea eliminar la localidad",
  CONFIRM_DELETE_LOCATION_MESSAGE:
    "Tenga en cuenta que ya no verá esta localidad en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_GENDER: "Está seguro de que desea eliminar el sexo biológico",
  CONFIRM_DELETE_GENDER_MESSAGE:
    "Tenga en cuenta que ya no verá este sexo biológico en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_APPOINTMENT_SECTOR:
    "Está seguro de que desea eliminar el sector",
  CONFIRM_DELETE_APPOINTMENT_SECTOR_MESSAGE:
    "Tenga en cuenta que ya no verá este sector en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_COORDINATION_TYPE:
    "Está seguro de que desea eliminar el tipo de coordinación",
  CONFIRM_DELETE_COORDINATION_TYPE_MESSAGE:
    "Tenga en cuenta que ya no verá este tipo en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_SPECIALTY: "Está seguro de que desea eliminar la especialidad",
  CONFIRM_DELETE_SPECIALTY_MESSAGE:
    "Tenga en cuenta que ya no verá esta especialidad en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_DOCTOR: "Está seguro de que desea eliminar el médico",
  CONFIRM_DELETE_DOCTOR_MESSAGE:
    "Tenga en cuenta que ya no verá el médico en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_COUNTRY: "Está seguro de que desea eliminar el país",
  CONFIRM_DELETE_COUNTRY_MESSAGE:
    "Tenga en cuenta que ya no verá al país en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_KINSHIP: "Está seguro de que desea eliminar el parentesco",
  CONFIRM_DELETE_KINSHIP_MESSAGE:
    "Tenga en cuenta que ya no verá este parentesco en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_MEDICAL_INSTITUTION:
    "Está seguro de que desea eliminar la institución médica",
  CONFIRM_DELETE_MEDICAL_INSTITUTION_MESSAGE:
    "Tenga en cuenta que ya no verá esta institución en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_PRODUCT: "Está seguro de que desea eliminar el producto",
  CONFIRM_DELETE_PRODUCT_MESSAGE:
    "Tenga en cuenta que ya no verá este producto en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_TYPES_PATERNITY_STUDY:
    "Está seguro de que desea eliminar el tipo de estudio de paternidad",
  CONFIRM_DELETE_TYPES_PATERNITY_STUDY_MESSAGE:
    "Tenga en cuenta que no volverá a ver la técnica, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_ETHNIC_ORIGIN: "Seguro que desea eliminar el origen étnico",
  CONFIRM_DELETE_ETHNIC_ORIGIN_MESSAGE:
    "Tenga en cuenta que ya no verá este origen étnico en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_SAMPLE_TYPE: "Seguro que desea eliminar el tipo de muestra",
  CONFIRM_DELETE_SAMPLE_TYPE_MESSAGE:
    "Tenga en cuenta que ya no verá este tipo de muestra en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_DOCUMENT_TYPE:
    "Seguro que desea eliminar el tipo de documento",
  CONFIRM_DELETE_DOCUMENT_TYPE_MESSAGE:
    "Tenga en cuenta que ya no verá este tipo de documento en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_MARKER: "Seguro que desea eliminar el marcador génetico",
  CONFIRM_DELETE_MARKER_MESSAGE:
    "Tenga en cuenta que ya no verá este marcador génetico en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_PROSPECT: "Seguro que desea eliminar el prospecto",
  CONFIRM_DELETE_PROSPECT_MESSAGE:
    "Tenga en cuenta que ya no verá este prospecto en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_EXTRACTION_METHOD:
    "Seguro que desea eliminar el método de extracción",
  CONFIRM_DELETE_EXTRACTION_METHOD_MESSAGE:
    "Tenga en cuenta que ya no verá este método de extracción en el sistema, pero guardaremos una copia de sus datos",

  CONFIRM_PASSWORD_CHANGE: "Quieres confirmar el cambio de contraseña",
  CONFIRM_PASSWORD_CHANGE_MESSAGE:
    "Se cambiará la clave del usuario y su sesión será cerrada, por lo que deberá volver a iniciar sesión",

  SELECT_OFFICE_MESSAGE:
    "Seleccione la oficina a la que desea asociar los datos",

  GENERAL_SCHEDULER_PAGE_TITLE: "Agenda",
  SCHEDULER_VIEW_TYPE_DAY: "Día",
  SCHEDULER_VIEW_TYPE_MONTH: "Mes",
  SCHEDULER_VIEW_TYPE_WEEK: "Semana",
  SCHEDULER_FORM_TITLE_LABEL: "Título",
  SCHEDULER_FORM_DESCRIPTION_LABEL: "Descripción",
  SCHEDULER_FORM_START_LABEL: "Comienzo",
  SCHEDULER_FORM_END_LABEL: "Fin",
  SCHEDULER_FORM_TYPES_LABEL: "Tipo de cita",
  SCHEDULER_FORM_TITLE_ERROR_REQUIRED: "Título es requerido",
  SCHEDULER_FORM_TITLE_ERROR_MAX_LENGTH:
    "Ingrese un máximo de {{max_length}} caracteres",
  SCHEDULER_FORM_DESCRIPTION_ERROR_MAX_LENGTH:
    "(Opcional) Ingrese un máximo de {{max_length}} caracteres",
  SCHEDULER_DIALOG_TITLE: "Agendar cita",
  SCHEDULER_FORM_NURSE_ERROR_REQUIRED: "Enfermero/a es requerido",
  SCHEDULER_NO_COORDINATION_TYPES_WARNING: "No hay tipos de coordinación activos en el sistema. Son necesarios para usar la agenda.",
  SCHEDULER_AGENDA_REPORT_DOWNLOAD: "Descargar reporte de hoy",
  SCHEDULER_AGENDA_EMPTY: "No hay citas para hoy",
  SCHEDULER_AGENDA_CLINICAL_DATA_MAX_LENGTH: "Dato clínico puede tener hasta {{max_length}} caracteres",
  SCHEDULER_AGENDA_CLINICAL_DATA_LABEL: "Dato clínico",
  SCHEDULER_AGENDA_DETAILS_MAX_LENGTH: "Detalles puede tener hasta {{max_length}} caracteres",
  SCHEDULER_AGENDA_DETAILS_LABEL: "Detalles",
  APPOINTMENT_SECTOR_REQUIRED: "Sector de cita requerido",
  COORDINATION_EXTRACTION: "Coordinación de extracción",
  COORDINATION_EXTRACTION_REQUIRED: "Coordinación de extracción es requerido",
  AGENDA_STATUS: 'Estado',
  AGENDA_STATUS_REQUIRED: 'Estado es requerido',
  AGENDA_REASON_FOR_CANCELLATION: 'Motivo de la cancelación',
  AGENDA_REASON_FOR_CANCELLATION_MAX_LENGTH: "Motivo de la cancelación puede tener hasta {{max_length}} caracteres",
  AGENDA_REASON_FOR_CANCELLATION_REQUIRED: "Motivo de la cancelación es requerido",
  AGENDA_INVALID_HOLDERS: "Titulares inválidos",
  AGENDA_REQUIRED_HOLDERS: "Titulares requeridos",
  AGENDA_HOLDER_VALIDATION_STATUS: "Válido",
  AGENDA_NEW: "Nueva cita",
  AGENDA_SKIP_AND_GO_BACK: 'Omitir y volver a la Agenda',
  AGENDA_GO_BACK_TO_DETAILS: "Volver al detalle",

  ADD_ATTACHMENT: "Nuevo adjunto",
  PDF_LABEL: "Archivo PDF",
  EXCEL_LABEL: "Archivo de Excel",
  WORD_LABEL: "Archivo de Word",
  PPT_LABEL: "Archivo de PowerPoint",
  XML_LABEL: "Archivo XML",
  TXT_LABEL: "Archivo de texto",
  IMAGE_LABEL: "Imagen",
  FILE_LABEL: "Archivo",
  DROP_FILE_LABEL:
    "Haz click aquí o arrastra los archivos para que sean subidos",
  DROP_FILE_LABEL_ACTIVE: "Suelta los archivos",
  DROP_FILE_ERROR_MESSAGE:
    "Ha ocurrido un error al procesar el archivo seleccionado",
  DROP_FILE_MAX_FILES_EXCEED_ERROR_MESSAGE:
    "Solo puede cargar 3 archivos a la vez",
  DROP_FILE_MAX_FILES_EXCEED_GROUP_ERROR_MESSAGE:
    "Solo puede subir un archivo para realizar asignación en grupo",
  DROP_FILES_SUCCESS_MESSAGE: "Archivos cargados correctamente",
  DROP_FILE_SUCCESS_MESSAGE: "Archivo cargado correctamente",
  DROP_FILE_EMPTY_LIST: "Sin archivos seleccionados",
  DROP_FILE_EMPTY: "Sin archivo seleccionado",
  FILE_ACCEPTED: "Archivo aceptado",
  FILE_SIZE_EXCEED: "El archivo supera los 10 MB",
  FILE_PICTURE_SIZE_EXCEED: "La foto supera los 10 MB",
  FILE_FOOTPRINT_1_SIZE_EXCEED: "La huella 1 supera los 10 MB",
  FILE_FOOTPRINT_2_SIZE_EXCEED: "La huella 2 supera los 10 MB",
  FILE_SIZE_EXCEED_MESSAGE: "Un archivo excede los 10 MB",
  FILE_NAME_DUPLICATED: "Nombre de archivo duplicado",
  SELECT_FILE: "Seleccionar archivo",
  STAGE_DUPLICATED: "Etapa duplicada",
  INDIVIDUAL_DUPLICATED:
    "El individuo ya se encuentra en el estudio de paternidad",
  STUDIES_EMPTY_LIST: "Sin estudios seleccionados",
  CLINICAL_ANALYSIS_EMPTY_LIST: "Sin análisis seleccionados",
  PROSPECTS_EMPTY_LIST: "Sin prospectos seleccionados",
  EMPTY_TASKS: "Sin tareas asignadas",
  WAITING_FOR_DATA_IMPORT: "Aguardando por importación de datos",
  //! Labels para referencias
  REFERENCE_SUCCESS: "Más de 5 días",
  REFERENCE_WARNING: "Entre 3 y 4 días",
  REFERENCE_DANGER: "Menos de 2 días",
  REFERENCE_IMPORT_SUCCESS: "Listo para procesar",
  REFERENCE_IMPORT_WARNING: "Ya tiene resultado",
  REFERENCE_IMPORT_DANGER: "No encontrado",
  REFERENCE_IMPORT_INCORRECT: "Faltan datos",
  REFERENCE_IMPORT_PROFILES_SUCCESS: "Listo para procesar",
  REFERENCE_IMPORT_PROFILES_WARNING:
    "Ya cuenta con un perfil genético asignado",
  REFERENCE_IMPORT_PROFILES_DANGER: "No se encontro el individuo",
  IMPORT_PROFILES_MESSAGE:
    "Unicamente se asociarán los perfiles de los individuos existentes",

  ANALYZES_RESULTS_PROCESS:
    "Serán actualizado/s un total de {{value}} análisis",
  ANALYZES_PROCESS: "Se añadirá un total de {{value}} análisis clinicos",
  PROSPECTS_PROCESS: "Se añadirá un total de {{value}} prospectos",
  NOTHING_PROCESS: "Nada por procesar",
  GENETIC_PROFILES_PROCESS: "Serán añadidos un total de {{value}} perfiles",

  INSTRUCTION_ENTER_TO_ADD: "Presione ENTER para agregar",
  INCORRECT_EMAIL_FORMAT: "Formato de email incorrecto",

  INDIVIDUAL_NOT_FOUND: "No se encontró individuo",
  NO_VISITS_THAT_RANGE: "Sin visitas para ese rango de fechas",
  DENIED_BY_ADMIN: "Acceso denegado por el administrador",

  METHOD_NOT_IMPLEMENTED: "Método no implementado",
  DEFAULT_MESSAGE_ERROR:
    "Ha ocurrido un error, por favor intentelo de nuevo más tarde",
  LANGUAGE: "Idioma",
  PT: "Portugués",
  ES: "Español",
  EN: "Inglés",
  LOADING: "Cargando",
  PENDING_CHANGES_ACTION: "Hay cambios sin guardar, confirma salir",
  PENDING_CHANGES: "Hay cambios sin guardar"
};
